import React, { useEffect, useState } from "react";
import { initAnalytics, logPageView } from "./analytics";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import TrainInfo from "./TrainInfo";
import TrainHistoryView from "./TrainHistoryView";
import SetTrainNumber from "./SetTrainNumber";
import PrivacyPolicy from "./PrivacyPolicy";
import Cookies from "./Cookies";
import Contact from "./Contact";
import StationDepartures from "./StationDepartures";

const G_ANALYTICS_TRACKING_ID = "G-WBXN6FKJ60";

const App: React.FC = () => {
  const [trainNumber, setTrainNumber] = useState(1);

  const TrainNumberAndDepartures: React.FC<{
    setTrainNumber: (trainNumber: number) => void;
  }> = ({ setTrainNumber }) => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <SetTrainNumber setTrainNumber={setTrainNumber} />
        <StationDepartures />
      </div>
    );
  };

  useEffect(() => {
    const storedConsent = localStorage.getItem("cookieConsent");
    if (storedConsent) {
      try {
        const consentData = JSON.parse(storedConsent);
        if (consentData.analytics === true) {
          initAnalytics(G_ANALYTICS_TRACKING_ID);
        }
      } catch (error) {
        console.error("Error parsing cookie consent data", error);
      }
    }
  }, []);

  //////////////////////////////////////////////////////////////////////////////////
  // Koodin kysymyskomponentti
  // const [isAuthorized, setIsAuthorized] = useState(false);
  // const CodePrompt: React.FC<{ onSuccess: () => void }> = ({ onSuccess }) => {
  //   const [code, setCode] = useState("");

  //   const handleSubmit = () => {
  //     if (code === "Deve777") {
  //       onSuccess();
  //     } else {
  //       alert("Väärä koodi. Yritä uudelleen.");
  //     }
  //   };

  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         flexDirection: "column",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         height: "100vh",
  //         backgroundColor: "white",
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: 240,
  //           fontSize: 9,
  //         }}
  //       >
  //         <p>
  //           Access is limited to authorized individuals who have been granted
  //           explicit permission. To proceed, you must enter the designated
  //           access code. If you do not have a valid code, you will not be able
  //           to continue. Core development workflows integrate CI/CD pipelines to
  //           streamline deployment frequency while mitigating integration debt
  //           through automated regression suites. Asynchronous communication
  //           protocols and event-driven paradigms further optimize inter-service
  //           orchestration in highly concurrent environments. Performance tuning
  //           involves deep profiling, leveraging A/B benchmarking to address
  //           bottlenecks at the computational and I/O layers, often employing
  //           lazy-loading strategies and CDN-backed edge caching to minimize
  //           latency. Security frameworks emphasize end-to-end encryption,
  //           tokenized session management, and compliance with OWASP guidelines,
  //           ensuring resilience against threat vectors.
  //         </p>
  //       </div>
  //       <input
  //         type="password"
  //         value={code}
  //         onChange={(e) => setCode(e.target.value)}
  //         placeholder=""
  //         style={{
  //           padding: "8px",
  //           fontSize: "16px",
  //           marginBottom: "8px",
  //           border: "1px solid gray",
  //           borderRadius: "4px",
  //         }}
  //       />
  //       <button
  //         onClick={handleSubmit}
  //         style={{
  //           padding: "2px 16px",
  //           fontSize: "16px",
  //           backgroundColor: "gray",
  //           color: "white",
  //           border: "none",
  //           cursor: "pointer",
  //         }}
  //       >
  //         Submit
  //       </button>
  //     </div>
  //   );
  // };
  //////////////////////////////////////////////////////////////////////////////////////

  return (
    <Router>
      <div className="App tausta m-0 p-0">
        {/* koodi */}
        {/* {!isAuthorized ? (
          <CodePrompt onSuccess={() => setIsAuthorized(true)} />
        ) : (
          <> */}
        {/* koodi */}
        <div
          style={{
            backgroundColor: "#1e5a72",
            color: "lightgray",
            fontSize: 18,
            fontWeight: 700,
            padding: 4,
            marginTop: "-8px",
            paddingTop: 12,
            borderRadius: 8,
            position: "relative",
            zIndex: 2,
            boxShadow: "2px 2px 25px rgba(0, 0, 0, 0.9)",
          }}
        >
          <Link to="/set-train-number" className="nav-link">
            minunjunani.fi
          </Link>
        </div>
        <div className="TrainInfo tausta">
          <div style={{ width: "92%", marginLeft: 8 }}>
            <div
              style={{
                position: "fixed",
                left: 55,
                top: 0,
                backgroundColor: "rgba(173, 173, 173, 0.140)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "100vh",
                width: "11px",

                paddingBottom: "-39px",
                borderLeft: "1px solid gray",
                borderRight: "1px solid gray",
              }}
            ></div>

            <AnalyticsWrapper>
              <Routes>
                <Route
                  path="/"
                  element={<Navigate to="/set-train-number" replace />}
                />
                <Route
                  path="/:trainNumber"
                  element={<TrainInfo trainNumber={trainNumber} />}
                />
                <Route
                  path="/history/:trainNumber"
                  element={<TrainHistoryView />}
                />
                <Route
                  path="/set-train-number"
                  element={
                    <TrainNumberAndDepartures setTrainNumber={setTrainNumber} />
                  }
                />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cookies" element={<Cookies />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </AnalyticsWrapper>
          </div>
        </div>
        {/* koodi */}
        {/* </>
        )} */}
        {/* koodi */}
      </div>
    </Router>
  );
};

const AnalyticsWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname);
  }, [location]);

  return <>{children}</>;
};

export default App;
